import { makeVar } from '@apollo/client';

export const defaultMethod = {
  id: null,
  name: '',
  code: '',
  typeId: null,
  percentIsMandatory: false,
  assetIsMandatory: false,
  ppIsMandatory: false,
  percentFormula: '',
  amountFormula: ''
};

export const methodModalVar = makeVar({
  open: false,
  method: defaultMethod
});
